/**
 * "AI transparency" — Trust section (ADR-0074).
 * Reconciled from the widget disclosure components (apps/widget/src/disclosure,
 * localized to all 6 locales), the /trust/ai model cards, and ADR-0081. The chat
 * LLM is Claude (managed) with OpenAI failover; Amazon Bedrock is embeddings
 * (Titan V2) + reranking only — NOT framed as "Claude via Bedrock". EU AI Act
 * Art. 50 is "in progress", so phrased "designed to meet". Links to /trust/ai.
 */
import type { DocPageContent } from '../types';

export const TRUST_AI_PAGE: DocPageContent = {
  slug: 'trust/ai',
  titleKey: 'docs.trust.ai.title',
  descriptionKey: 'docs.trust.ai.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.trust.ai.lead' },

    { kind: 'heading', level: 2, id: 'disclosure', textKey: 'docs.trust.ai.disclosure.heading' },
    { kind: 'paragraph', textKey: 'docs.trust.ai.disclosure.body' },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.trust.ai.disclosure.note.title',
      textKey: 'docs.trust.ai.disclosure.note.body',
      links: {
        languages: {
          target: { docSlug: 'languages' },
          labelKey: 'docs.trust.ai.disclosure.note.link',
        },
      },
    },

    { kind: 'heading', level: 2, id: 'models', textKey: 'docs.trust.ai.models.heading' },
    { kind: 'paragraph', textKey: 'docs.trust.ai.models.body' },
    {
      kind: 'definitions',
      items: [
        { termKey: 'docs.trust.ai.model.chat.term', descKey: 'docs.trust.ai.model.chat.desc' },
        {
          termKey: 'docs.trust.ai.model.embeddings.term',
          descKey: 'docs.trust.ai.model.embeddings.desc',
        },
        { termKey: 'docs.trust.ai.model.byok.term', descKey: 'docs.trust.ai.model.byok.desc' },
      ],
    },

    { kind: 'heading', level: 2, id: 'grounding', textKey: 'docs.trust.ai.grounding.heading' },
    { kind: 'paragraph', textKey: 'docs.trust.ai.grounding.body' },

    {
      kind: 'callout',
      tone: 'tip',
      titleKey: 'docs.trust.ai.more.title',
      textKey: 'docs.trust.ai.more.body',
      links: {
        ai: { target: { path: '/trust/ai' }, labelKey: 'docs.trust.common.link.ai' },
      },
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.trust.ai.next.knowledge.title',
          textKey: 'docs.trust.ai.next.knowledge.text',
          to: { docSlug: 'dashboard/knowledge' },
        },
        {
          titleKey: 'docs.trust.ai.next.compliance.title',
          textKey: 'docs.trust.ai.next.compliance.text',
          to: { docSlug: 'trust/compliance' },
        },
      ],
    },
  ],
};
